module.exports = __webpack_public_path__ + "assets/images_base/st-avatar-white.svg?v=17a1a3c1";